
<!--==============================
=            chartist            =
===============================-->

<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Chartist</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="smil-animations" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="simple-line-chart" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="scatter-diagram" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="line-chart-tooltips" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="chart-with-area" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="bi-polar-line" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="svg-animation" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="line-smoothing" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="bi-polar-bar" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header"></div>
          <div slot="card-body">
            <div id="overlapping-bars" class="ct-chart ct-golden-section"></div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  mounted() {
    var chart = new Chartist.Line(
      "#smil-animations",
      {
        labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
        series: [
          [12, 9, 7, 8, 5, 4, 6, 2, 3, 3, 4, 6],
          [4, 5, 3, 7, 3, 5, 5, 3, 4, 4, 5, 5],
          [5, 3, 4, 5, 6, 3, 3, 4, 5, 6, 3, 4],
          [3, 4, 5, 6, 7, 6, 4, 5, 6, 7, 6, 3]
        ]
      },
      {
        low: 0,
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    // Let's put a sequence number aside so we can use it in the event callbacks
    var seq = 0,
      delays = 80,
      durations = 500;

    // Once the chart is fully created we reset the sequence
    chart.on("created", function() {
      seq = 0;
    });

    // On each drawn element by Chartist we use the Chartist.Svg API to trigger SMIL animations
    chart.on("draw", function(data) {
      seq++;

      if (data.type === "line") {
        // If the drawn element is a line we do a simple opacity fade in. This could also be achieved using CSS3 animations.
        data.element.animate({
          opacity: {
            // The delay when we like to start the animation
            begin: seq * delays + 1000,
            // Duration of the animation
            dur: durations,
            // The value where the animation should start
            from: 0,
            // The value where it should end
            to: 1
          }
        });
      } else if (data.type === "label" && data.axis === "x") {
        data.element.animate({
          y: {
            begin: seq * delays,
            dur: durations,
            from: data.y + 100,
            to: data.y,
            // We can specify an easing function from Chartist.Svg.Easing
            easing: "easeOutQuart"
          }
        });
      } else if (data.type === "label" && data.axis === "y") {
        data.element.animate({
          x: {
            begin: seq * delays,
            dur: durations,
            from: data.x - 100,
            to: data.x,
            easing: "easeOutQuart"
          }
        });
      } else if (data.type === "point") {
        data.element.animate({
          x1: {
            begin: seq * delays,
            dur: durations,
            from: data.x - 10,
            to: data.x,
            easing: "easeOutQuart"
          },
          x2: {
            begin: seq * delays,
            dur: durations,
            from: data.x - 10,
            to: data.x,
            easing: "easeOutQuart"
          },
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: "easeOutQuart"
          }
        });
      } else if (data.type === "grid") {
        // Using data.axis we get x or y which we can use to construct our animation definition objects
        var pos1Animation = {
          begin: seq * delays,
          dur: durations,
          from: data[data.axis.units.pos + "1"] - 30,
          to: data[data.axis.units.pos + "1"],
          easing: "easeOutQuart"
        };

        var pos2Animation = {
          begin: seq * delays,
          dur: durations,
          from: data[data.axis.units.pos + "2"] - 100,
          to: data[data.axis.units.pos + "2"],
          easing: "easeOutQuart"
        };

        var animations = {};
        animations[data.axis.units.pos + "1"] = pos1Animation;
        animations[data.axis.units.pos + "2"] = pos2Animation;
        animations["opacity"] = {
          begin: seq * delays,
          dur: durations,
          from: 0,
          to: 1,
          easing: "easeOutQuart"
        };

        data.element.animate(animations);
      }
    });

    // For the sake of the example we update the chart every time it's created with a delay of 10 seconds
    chart.on("created", function() {
      if (window.__exampleAnimateTimeout) {
        clearTimeout(window.__exampleAnimateTimeout);
        window.__exampleAnimateTimeout = null;
      }
      window.__exampleAnimateTimeout = setTimeout(
        chart.update.bind(chart),
        12000
      );
    });

    //Simple line chart
    new Chartist.Line(
      "#simple-line-chart",
      {
        labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        series: [
          [12, 9, 7, 8, 5],
          [2, 1, 3.5, 7, 3],
          [1, 3, 4, 5, 6]
        ]
      },
      {
        fullWidth: true,
        chartPadding: {
          right: 40
        },
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    //Line Scatter Diagram
    var times = function(n) {
      return Array.apply(null, new Array(n));
    };

    var data = times(52)
      .map(Math.random)
      .reduce(
        function(data, rnd, index) {
          data.labels.push(index + 1);
          data.series.forEach(function(series) {
            series.push(Math.random() * 100);
          });

          return data;
        },
        {
          labels: [],
          series: times(4).map(function() {
            return new Array();
          })
        }
      );

    var options = {
      showLine: false,
      axisX: {
        labelInterpolationFnc: function(value, index) {
          return index % 13 === 0 ? "W" + value : null;
        }
      }
    };

    var responsiveOptions = [
      [
        "screen and (min-width: 640px)",
        {
          axisX: {
            labelInterpolationFnc: function(value, index) {
              return index % 4 === 0 ? "W" + value : null;
            }
          }
        }
      ]
    ];

    new Chartist.Line("#scatter-diagram", data, options, responsiveOptions);

    //Line chart with tooltips

    //Line chart with tooltips

    new Chartist.Line(
      "#line-chart-tooltips",
      {
        labels: ["1", "2", "3", "4", "5", "6"],
        series: [
          {
            name: "Fibonacci sequence",
            data: [1, 2, 3, 5, 8, 13]
          },
          {
            name: "Golden section",
            data: [1, 1.618, 2.618, 4.236, 6.854, 11.09]
          }
        ]
      },
      {
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    var $chart = $("#line-chart-tooltips");

    var $toolTip = $chart
      .append('<div class="tooltip"></div>')
      .find(".tooltip")
      .hide();

    $chart.on("mouseenter", ".ct-point", function() {
      var $point = $(this),
        value = $point.attr("ct:value"),
        seriesName = $point.parent().attr("ct:series-name");
      $toolTip.html(seriesName + "<br>" + value).show();
    });

    $chart.on("mouseleave", ".ct-point", function() {
      $toolTip.hide();
    });

    $chart.on("mousemove", function(event) {
      $toolTip.css({
        left:
          (event.offsetX || event.originalEvent.layerX) -
          $toolTip.width() / 2 -
          10,
        top:
          (event.offsetY || event.originalEvent.layerY) - $toolTip.height() - 40
      });
    });

    //Line chart with area

    new Chartist.Line(
      "#chart-with-area",
      {
        labels: [1, 2, 3, 4, 5, 6, 7, 8],
        series: [[5, 9, 7, 8, 5, 3, 5, 4]]
      },
      {
        low: 0,
        showArea: true,
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    //Bi-polar Line chart with area only

    new Chartist.Line(
      "#bi-polar-line",
      {
        labels: [1, 2, 3, 4, 5, 6, 7, 8],
        series: [
          [1, 2, 3, 1, -2, 0, 1, 0],
          [-2, -1, -2, -1, -2.5, -1, -2, -1],
          [0, 0, 0, 1, 2, 2.5, 2, 1],
          [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
        ]
      },
      {
        high: 3,
        low: -3,
        showArea: true,
        showLine: false,
        showPoint: false,
        fullWidth: true,
        axisX: {
          showLabel: false,
          showGrid: false
        },
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    //SVG Path animation

    var chart = new Chartist.Line(
      "#svg-animation",
      {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        series: [
          [1, 5, 2, 5, 4, 3],
          [2, 3, 4, 8, 1, 2],
          [5, 4, 3, 2, 1, 0.5]
        ]
      },
      {
        low: 0,
        showArea: true,
        showPoint: false,
        fullWidth: true
      }
    );

    chart.on("draw", function(data) {
      if (data.type === "line" || data.type === "area") {
        data.element.animate({
          d: {
            begin: 2000 * data.index,
            dur: 2000,
            from: data.path
              .clone()
              .scale(1, 0)
              .translate(0, data.chartRect.height())
              .stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint
          }
        });
      }
    });

    //Line Interpolation / Smoothing

    var chart = new Chartist.Line(
      "#line-smoothing",
      {
        labels: [1, 2, 3, 4, 5],
        series: [
          [1, 5, 10, 0, 1],
          [10, 15, 0, 1, 2]
        ]
      },
      {
        // Remove this configuration to see that chart rendered with cardinal spline interpolation
        // Sometimes, on large jumps in data values, it's better to use simple smoothing.
        lineSmooth: Chartist.Interpolation.simple({
          divisor: 2
        }),
        fullWidth: true,
        chartPadding: {
          right: 20
        },
        low: 0,
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    //Bi-polar bar chart

    var data = {
      labels: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9", "W10"],
      series: [[1, 2, 4, 8, 6, -2, -1, -4, -6, -2]]
    };

    var options = {
      high: 10,
      low: -10,
      axisX: {
        labelInterpolationFnc: function(value, index) {
          return index % 2 === 0 ? value : null;
        }
      },
      plugins: [Chartist.plugins.tooltip()]
    };

    new Chartist.Bar("#bi-polar-bar", data, options);

    //Overlapping bars on mobile

    var data = {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      series: [
        [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
        [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
      ]
    };

    var options = {
      seriesBarDistance: 10
    };

    var responsiveOptions = [
      [
        "screen and (max-width: 640px)",
        {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function(value) {
              return value[0];
            }
          }
        }
      ]
    ];

    new Chartist.Bar("#overlapping-bars", data, options, responsiveOptions);

    //Multi-line labels

    // eslint-disable-next-line no-undef
    new Chartist.Bar(
      "#multi-line-chart",
      {
        labels: [
          "First quarter of the year",
          "Second quarter of the year",
          "Third quarter of the year",
          "Fourth quarter of the year"
        ],
        series: [
          [60000, 40000, 80000, 70000],
          [40000, 30000, 70000, 65000],
          [8000, 3000, 10000, 6000]
        ]
      },
      {
        seriesBarDistance: 10,
        axisX: {
          offset: 60
        },
        axisY: {
          offset: 80,
          labelInterpolationFnc: function(value) {
            return value + " CHF";
          },
          scaleMinSpace: 15
        },
        plugins: [Chartist.plugins.tooltip()]
      }
    );

    //Stacked bar chart

    new Chartist.Bar(
      "#stacked-bar-chart",
      {
        labels: ["Q1", "Q2", "Q3", "Q4"],
        series: [
          [800000, 1200000, 1400000, 1300000],
          [200000, 400000, 500000, 300000],
          [160000, 290000, 410000, 600000]
        ]
      },
      {
        stackBars: true,
        axisY: {
          labelInterpolationFnc: function(value) {
            return value / 1000 + "k";
          }
        },
        plugins: [Chartist.plugins.tooltip()]
      }
    ).on("draw", function(data) {
      if (data.type === "bar") {
        data.element.attr({
          style: "stroke-width: 30px"
        });
      }
    });
  }
};
</script>

<style scoped>
.height-400 {
  height: 400px;
}
</style>
<!--====  End of chartist  ====-->